﻿<template>
    <q-dialog ref="dialogRef" class="auto-width" @hide="onDialogHide">
        <q-card>
            <q-card-section class="items-center">
                <q-markup-table flat dense>
                    <thead>
                        <tr>
                            <th class="text-left">{{ ts('boat') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="boat in boatList" :key="boat.id">
                            <td>
                                {{ boat.label }}
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="ts('close')" color="primary" @click="onDialogCancel" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar'
import { ts } from '@/plugins/i18nFormat'
import { ref } from 'vue'

interface Props {
    color?: string
    boatList: object[]
}

const props = withDefaults(defineProps<Props>(), {
    icon: 'info',
    color: 'primary',
})

defineEmits([...useDialogPluginComponent.emits])

const boatList = ref(props.boatList)

const { dialogRef, onDialogHide, onDialogCancel } = useDialogPluginComponent()
</script>

<style scoped lang="sass">
.auto-width > div > div
    max-width: none !important
</style>
